// extracted by mini-css-extract-plugin
module.exports = {"contacts":"Contacts_contacts__3DKJ1","icon":"Contacts_icon__3Iexo","info":"Contacts_info__3L_3T","value":"Contacts_value__1C0IC"};